import { Link } from 'react-router-dom';

function VPN() {
  return (
    <div className="py-20">
      <div className="container mx-auto px-4">
        {/* Hero */}
        <div className="text-center mb-16 max-w-4xl mx-auto">
          <span className="inline-block px-4 py-2 bg-cyber-blue/20 text-cyber-blue rounded-full text-sm font-semibold mb-4">
            ENTERPRISE VPN
          </span>
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="gradient-text">Secure Remote Access</span>
            <br />
            <span className="text-white">At Scale</span>
          </h1>
          <p className="text-xl text-gray-400 mb-8">
            Connect your distributed workforce with military-grade encryption and zero-trust architecture.
          </p>
          <Link to="/contact" className="btn-primary text-lg">
            Request Demo
          </Link>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Zero-Trust Network Access</h3>
            <p className="text-gray-400">
              Verify every user and device before granting access. No implicit trust, ever.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">AES-256 Encryption</h3>
            <p className="text-gray-400">
              Military-grade encryption protects your data in transit across all networks.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Global Network</h3>
            <p className="text-gray-400">
              100+ PoPs worldwide with automatic failover and load balancing.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Multi-Platform Support</h3>
            <p className="text-gray-400">
              Native clients for Windows, macOS, Linux, iOS, and Android.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">Split Tunneling</h3>
            <p className="text-gray-400">
              Route corporate traffic through VPN while keeping personal traffic direct.
            </p>
          </div>

          <div className="card">
            <h3 className="text-xl font-bold mb-3 text-white">MFA Integration</h3>
            <p className="text-gray-400">
              Seamless integration with your existing identity providers and MFA solutions.
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="card text-center bg-gradient-to-r from-cyber-blue/10 to-cyber-purple/10">
          <h2 className="text-3xl font-bold mb-4 text-white">Ready to Secure Your Remote Workforce?</h2>
          <p className="text-gray-400 mb-6 max-w-2xl mx-auto">
            Join thousands of companies protecting their data with Velumcloud VPN.
          </p>
          <Link to="/contact" className="btn-primary">
            Contact Sales
          </Link>
        </div>
      </div>
    </div>
  );
}

export default VPN;
